<template>
  <router-link
    class="c-navbar__logo"
    :to="{ name: RouteName.HOME }"
  >
    <component
      :is="logoTag"
      class="u-visually-hidden"
    >
      {{ tenantLogoAlt }}
    </component>
    <img
      :alt="tenantLogoAlt"
      :src="tenantLogoSrc"
    >
  </router-link>
</template>

<script>
  import { RouteName } from '@/shared/enums';
  import { tenantMixin } from '@/shared/mixins';

  export default {
    enums: {
      RouteName,
    },
    mixins: [
      tenantMixin,
    ],
    computed: {
      logoTag() {
        return [RouteName.HOME, RouteName.KIDS_HOME].includes(this.$route.name) ? 'h1' : 'h2';
      },
    },
  };
</script>
